// Smoke particle fragment — wispy warm-grey blobs

varying float vAlpha;

void main() {
    vec2  uv   = gl_PointCoord - vec2(0.5);
    float dist = length(uv) * 2.0;

    // Very soft edge — smoke is wispy and diffuse
    float alpha = 1.0 - smoothstep(0.0, 1.0, dist);
    alpha = pow(alpha, 0.55);

    // Warm grey-white, slightly warm-toned for candle palette
    vec3 col = mix(vec3(0.72, 0.68, 0.65), vec3(0.94, 0.92, 0.90), 1.0 - dist * 0.7);

    gl_FragColor = vec4(col, alpha * vAlpha * 0.50);

    #include <colorspace_fragment>
}
